var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5008H17.5M5 15.0008V8.33417M8.33333 15.0008V8.33417M11.6667 15.0008V8.33417M15 15.0008V8.33417M16.6667 5.83417L10.3533 1.88833C10.2252 1.80822 10.1611 1.76816 10.0923 1.75255C10.0315 1.73873 9.96845 1.73873 9.90767 1.75255C9.83894 1.76816 9.77485 1.80822 9.64667 1.88833L3.33333 5.83417H16.6667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryAdmin);
export default __webpack_public_path__ + "static/media/category-admin.e603efbda92834443f52ea3bd0bc4ec4.svg";
export { ForwardRef as ReactComponent };